import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { ProFormList } from '../../List';
export var formList = function formList(item, _ref) {
  var genItems = _ref.genItems;

  if (item.valueType === 'formList' && item.dataIndex) {
    var _item$getFieldProps;

    if (!item.columns || !Array.isArray(item.columns)) return null;
    return /*#__PURE__*/React.createElement(ProFormList, _extends({
      key: item.key,
      name: item.dataIndex,
      label: item.label,
      initialValue: item.initialValue,
      colProps: item.colProps,
      rowProps: item.rowProps
    }, (_item$getFieldProps = item.getFieldProps) === null || _item$getFieldProps === void 0 ? void 0 : _item$getFieldProps.call(item)), genItems(item.columns));
  }

  return true;
};